import { Stack } from '@mui/material';
import { useEffect } from 'react';
import ReactGA from 'react-ga';
import { Helmet } from 'react-helmet-async';
import { MotionViewport } from 'src/components/animate';
import Catalogo from 'src/features/components/catalogo';
import ImageViewer from 'src/features/components/lightbox';
import { organization } from 'src/features/global';

// ----------------------------------------------------------------------------------

export default function ToldosLonaPage() {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname);
  }, []);

  return (
    <Stack component={MotionViewport}>
      <Helmet>
        <title> Toldos em Lona {organization}</title>
      </Helmet>

      <Catalogo label="Toldos em Lona">
        <ImageViewer length={5} folder="categoria/toldoslona" label="Toldos em Lona" exe="webp" />
      </Catalogo>
    </Stack>
  );
}
